import { useEffect, useState } from "react";
import { styled } from "~/common/mui";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const StyledButton = styled("div")(({ theme }) => ({
  position: "fixed",
  bottom: theme.spacing(4), // 32px
  right: theme.spacing(2), // 16px
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 40,
  height: 40,
  borderRadius: "50%",
  transition: "opacity 0.4s",
  boxShadow: `0 0 0 1px ${theme.palette.divider}`,
  background: "rgba(246, 247, 248, 0.92)",
  cursor: "pointer",
  // Icon styling
  "& i": {
    ...theme.typography.headlineSmall,
  },
  // Mobile styles
  [theme.breakpoints.down("tablet")]: {
    right: theme.spacing(1), // 8px
    bottom: 80, // 56px (height from sticky navbar) + 24px
    width: 32,
    height: 32,
    "& i": {
      ...theme.typography.titleMedium,
    },
  },
}));

export const ScrollToTop = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onScroll = () => {
    const scrolled = window.scrollY;
    const windowHeight = window.innerHeight;
    scrolled > windowHeight ? setShowButton(true) : setShowButton(false);
  };

  return (
    <StyledButton sx={{ opacity: showButton ? 1 : 0 }} onClick={() => window.scroll(0, 0)}>
      <KeyboardArrowUpIcon  />
    </StyledButton>
  );
};
